import {
  formatDate,
  BaseTransaction,
  formatBalance,
  BaseellaStatusTitle,
  Currency,
} from '@ui/src';
import getGeneralLedgerStatusTitle from '../../general-ledger/helpers/get-gl-enum-names';

import cn from '../../incoming/styles.module.css';

const formatInternalList = ({
  list,
  currenciesList,
}: {
  list: BaseTransaction[];
  currenciesList?: Currency[];
}): BaseTransaction[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const currentCurrency = currenciesList?.find(
      (currency) => currency.id === result?.currencyId,
    );

    const render: Record<string, any> = {
      transferDate: <div>{formatDate(result?.transferDate || '', true)}</div>,
      currencyId: <div>{result?.currency?.name || ''}</div>,
      recipientAccountNumber: result?.recipientAccount ? (
        <>
          <div>{result?.recipientAccount?.description}</div>
          <div className={cn.accNumber}>
            {result?.recipientAccount?.fullNumber}
          </div>
        </>
      ) : (
        result.recipientAccountNumber
      ),
      senderAccountNumber: result?.senderAccount ? (
        <>
          <div>{result?.senderAccount?.description}</div>
          <div className={cn.accNumber}>
            {result?.senderAccount?.fullNumber}
          </div>
        </>
      ) : (
        result.senderAccountNumber
      ),
      sum: <div>{formatBalance(result.sum, currentCurrency)}</div>,
      sumBaseCurrency: (
        <div>
          {result.sumBaseCurrency
            ? formatBalance(result.sumBaseCurrency, currentCurrency)
            : '—'}
        </div>
      ),
      baseellaStatus: <div>{BaseellaStatusTitle[result.baseellaStatus]}</div>,
      values: result.generalLedgerTransactions?.edges.map((el) => el.node),
    };

    result.render = render;

    const nextResult = {
      ...result,
      values:
        result.generalLedgerTransactions?.edges.map((el) => {
          const gl = el.node;

          const glCurrency = currenciesList?.find(
            (currency) => currency.id === gl?.currencyId,
          );

          return {
            ...gl,
            render: {
              transferDate: (
                <div>{formatDate(gl?.transferDate || '', true)}</div>
              ),
              currencyId: <div>{gl?.currency.name || ''}</div>,
              debitAccountId: <div>{gl?.debitAccount?.fullNumber || ''}</div>,
              creditAccountId: <div>{gl?.creditAccount?.fullNumber || ''}</div>,
              debitAccount: <div>{gl?.debitAccount?.description || ''}</div>,
              creditAccount: <div>{gl?.creditAccount?.description || ''}</div>,
              sum: <div>{formatBalance(gl.sum, glCurrency)}</div>,
              status: (
                <div>{getGeneralLedgerStatusTitle(gl?.status || '')}</div>
              ),
            },
          };
        }) || [],
    };

    return nextResult;
  });

  return nextList;
};

export default formatInternalList;
